import getServiceMembersByServiceId from '~/api/getServiceMembersByServiceId';
import { prop, map, applySpec } from 'ramda';
import { SelectBase } from '~/components/SelectBase';
import { withSelect2 } from './withSelect2';

const result = applySpec({
	id: prop('ID'),
	text: prop('NAME'),
});

export const Select2ServiceCenterMember = {
	name: 'Select2ServiceCenterMember',
	extends: SelectBase,
	props: {
		serviceId: [String, Number],
	},
	mixins: [
		withSelect2(vm => ({
			ajax: {
				transport: (params, success, failure) => {
					getServiceMembersByServiceId(vm.serviceId, params.data.q)
						.then(success)
						.catch(failure);
				},
				processResults: (results) => ({
					results: map(result, results),
				}),
			},
			width: '100%',
		})),
	],
}
